module.exports = __webpack_public_path__ + "img/业务介绍物业2.3c51eb96.jpg";